import * as React from 'react';
import styled from 'styled-components';
import { brightNavy, paleGrey } from '../../cssConstants';

const Checkbox = (props: Props) => {
	return (
		<Wrapper className={props.className}>
			<CheckboxInput
				name={props.name}
				value={props.value}
				onValueChange={props.onValueChange}
				onChange={props.onChange}
				disabled={props.disabled}
				required={props.required}
			/>
			<label className="k-checkbox-label" htmlFor={props.name}>
				{props.label}
			</label>
		</Wrapper>
	);
};

interface Props extends CheckboxInputProps {
	label: string;
	className?: string;
}

Checkbox.defaultProps = {
	className: null,
	disabled: false,
	onChange: null,
	onValueChange: null
};

export default Checkbox;

export const CheckboxInput = (props: CheckboxInputProps) => {
	const handleChange = () => props.onValueChange(props.name, !props.value);
	return (
		<CheckboxInputElement
			id={props.name}
			checked={props.value}
			className="k-checkbox"
			type="checkbox"
			name={props.name}
			required={props.required}
			onChange={props.onChange ?? handleChange}
			disabled={props.disabled}
		/>
	);
};

interface CheckboxInputProps {
	name: string;
	value: boolean;
	disabled?: boolean;
	required?: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onValueChange?: (name: string, value: unknown) => void;
}

CheckboxInput.defaultProps = {
	disabled: false,
	onChange: null,
	onValueChange: null
};

const Wrapper = styled.div`
	display: inline-block;
	margin-bottom: 20px;
`;

export const CheckboxInputElement = styled.input`
	margin-right: 10px;
	min-width: 16px; /* This is needed to stop a flex parent from squashing the width of the checkbox. */
	border-color: ${paleGrey};

	:checked,
	::before {
		border-color: ${brightNavy};
		background-color: ${brightNavy};
		color: white;
	}
`;

export const CheckboxWrapper = styled.label`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	cursor: pointer;
	line-height: 1.4;
	width: 100%;
	box-sizing: border-box;
`;

export const CheckboxInputElementFullLength = styled.input`
	margin: 0;
	width: 16px;
	height: 16px;
	min-width: 16px;
	flex-shrink: 0;
	border: 1px solid ${paleGrey};
	border-radius: 2px;
	cursor: pointer;
	}

	:checked {
		border-color: ${brightNavy};
		background-color: ${brightNavy};
		color: white;
	}
`;

export const CheckboxLabelText = styled.span`
	flex: 1;
	width: 100%;
	line-height: 1.4;
	font-size: 14px;
	color: #262626;
	opacity: 0.65;
	word-wrap: break-word;
	hyphens: auto;
	margin-top: -2px;
`;
